import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="min-h-[60vh] flex items-center justify-center pt-16">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center text-foreground-300">
              <i className="ri-error-warning-line text-4xl"></i>
            </div>
            <h2 className="text-xl font-semibold text-foreground-800 mb-2">分类未找到</h2>
            <p className="text-foreground-500">请检查分类地址是否正确</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const categoryArticles = articles.filter((a) => a.categoryId === category.id);
  const otherCategories = categories.filter((c) => c.id !== category.id);

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${category.name} - 黑料网不打烊`}
        description={`黑料网不打烊${category.name}频道，${category.description}。24小时持续更新，最新最全的${category.name}黑料资讯。`}
        keywords={`${category.name},${category.name}黑料,${category.name}爆料,黑料网不打烊`}
        canonicalUrl={`https://heiliao-budayang.com/category/${category.slug}`}
        ogTitle={`${category.name} - 黑料网不打烊`}
        ogDescription={category.description}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${category.name} - 黑料网不打烊`,
            description: category.description,
            url: `https://heiliao-budayang.com/category/${category.slug}`,
            isPartOf: {
              '@type': 'WebSite',
              name: '黑料网不打烊',
              url: 'https://heiliao-budayang.com/',
            },
          }),
        }}
      />

      <Navbar />

      <main className="pt-16">
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]} />

            <div className="flex items-center gap-4 mb-2">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${category.icon} text-2xl`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">{category.name}</h1>
                <p className="text-sm text-foreground-500 mt-1">{category.description}</p>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-wrap gap-2 mb-8">
              {otherCategories.map((cat) => (
                <a
                  key={cat.id}
                  href={`/category/${cat.slug}`}
                  className="px-4 py-2 rounded-full text-sm font-medium bg-background-100 text-foreground-600 border border-background-200/60 hover:border-primary-200 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>

            {categoryArticles.length === 0 ? (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center text-foreground-300">
                  <i className="ri-inbox-line text-4xl"></i>
                </div>
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}